<ng-progress [spinner]="false" [color]="'#7ab655'"></ng-progress>

<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="!finish">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p id="loadingText">Loading, please wait...</p>
                    </div>
                </ng-container>

                <div *ngIf="finish" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <div>
                        <h1 class="h3 mb-0 text-gray-800">{{client}}</h1>
                        <div class="pRelative" style="margin-top: 14px;">
                            <p style="line-height:0">{{assessmentName}}</p>
                            <p style="margin-bottom: 4px;">Completed on: {{completedOn}}</p>
                        </div>
                    </div>

                    <div class="btns-container buttonsSpacing">
                        <!--<a (click)="back()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                            <i class="fas fa- text-white-50"> <span class="button-text">Assessments</span></i>
                        </a>-->
                        <a (click)="downloadAssessment()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-download text-white-50"> <span class="button-text">Download Report</span></i>
                        </a>
                    </div>
                </div>


                <div class="" *ngIf="finish">

                    <!--<div *ngIf="show360Section">-->
                    <ul class="tab-nav">
                        <li class="active"><a data-toggle="tab" href="#AboutTab">ELI Report</a></li>
                        <li><a data-toggle="tab" href="#ELITab">Results</a></li>
                        <li *ngIf="IsMODIII && !is360;" (click)="tabSelect(1)"><a data-toggle="tab" href="#Tab2">Answers</a></li>
                        <li *ngIf="show360Section"><a data-toggle="tab" href="#360Tab">360</a></li>
                    </ul>
                    <!--</div>-->

                    <div class="main-tab-content tab-content">

                        <div id="AboutTab" class="tab-pane fade in active">
                            <ng-container *ngIf="loading">
                                <div class="text-center">
                                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                                    <p>Loading, please wait...</p>
                                </div>
                            </ng-container>

                            <div class="container-fluid" id="content"></div>
                        </div>

                        <div id="ELITab" class="tab-pane fade">
                            <div class="container-fluid">
                                <ng-container *ngIf="finish">

                                    <div class="row">
                                        <!--graphic-->
                                        <div class="col-md-9 images">
                                            <div class="graphics">
                                                <div style="display: block">
                                                    <!--<p class="graphicTitle">{{graphicTitle1}}</p>-->
                                                    <p class="graphicTitle">Your Energetic Profile </p>
                                                    <!--<i [popover]="ep" class="fas fa-question-circle pointer"></i>-->
                                                    <!--<popover-content #ep
                                                    title="Energetic Profile"
                                                    placement="right"
                                                    [animation]="true"
                                                    [closeOnClickOutside]="true">
                                    <p>This chart shows your current status for each energy level.</p>
                                </popover-content>-->

                                                    <div class="graphicsValues" style="position:relative;">
                                                        <div>
                                                            <p *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">Level {{7 - i}}</p>
                                                            <span *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                        </div>
                                                        <span *ngFor="let level of levels1; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                        <canvas baseChart
                                                                [datasets]="ERGraphicDatasets"
                                                                [labels]="ERGraphicLabel"
                                                                [options]="ERGraphicOptions"
                                                                [legend]="ERGraphicLegend"
                                                                [chartType]="ERGraphicChartType"
                                                                [colors]="colors"></canvas>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <br />

                                    <div class="row">
                                        <div class="col-md-9 images">
                                            <div class="graphics">
                                                <div style="display: block">
                                                    <!--<p class="graphicTitle">{{graphicTitle2}}</p>-->
                                                    <p class="graphicTitle">Your Energetic Stress Reaction </p>
                                                    <!--<i [popover]="esr" class="fas fa-question-circle pointer"></i>
                                <popover-content #esr
                                                    title="Energetic Stress Reaction"
                                                    placement="right"
                                                    [animation]="true"
                                                    [closeOnClickOutside]="true">
                                    <p>This chart shows how you react under stress conditions according to your energy levels.</p>
                                </popover-content>-->

                                                    <div class="graphicsValues" style="position:relative;">
                                                        <div>
                                                            <p *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">Level {{7 - i}}</p>
                                                            <span *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                        </div>
                                                        <span *ngFor="let level of levels2; let i = index;" class="level{{7-i}}">{{level}}%</span>
                                                        <canvas baseChart
                                                                [datasets]="ERPGraphicDatasets"
                                                                [labels]="ERPGraphicLabel"
                                                                [options]="ERPGraphicOptions"
                                                                [legend]="ERPGraphicLegend"
                                                                [chartType]="ERPGraphicChartType"
                                                                [colors]="colors"></canvas>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <br />

                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="subTitle" style="margin-left:15px;font-weight:bold;">
                                                Your Average Resonating Level of Energy (ARL) is :
                                                <span class="alv"> {{ARL.Values[0].Value}} </span>
                                            </p>

                                            <!--<i [popover]="arl" class="fas fa-question-circle pointer"></i>
                        <popover-content #arl
                                         title="ARL"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>This number represents your ability to...</p>
                            <video id="video" controls height="100" width="245">
                                <source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/mp4">
                                <source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/ogg">
                                Your browser does not support HTML5 video.
                            </video>
                        </popover-content>-->
                                        </div>
                                    </div>

                                    <br />

                                </ng-container>

                            </div>
                        </div>

                        <div *ngIf="IsMODIII && !is360;" id="Tab2" class="tab-pane fade">
                            <div>
                                <br />

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="container-fluid">
                                            <p style="margin-bottom:-15px;" class="negativelyKeyed">Note: Questions displayed in red are "negatively keyed," indicating that the response scale is reversed</p>
                                        </div>
                                    </div>
                                </div>

                                <div style="margin-top: 30px;" *ngFor="let section of assessmentAnswers; let i = index;">

                                    <ng-container *ngIf="section.SectionId == 2" class="row">
                                        <div class="col-md-12">
                                            <div class="container-fluid noPadding">
                                                <h4>Satisfaction Answers</h4>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <div class="row answerLevels" *ngFor="let answer of section.Answers ">
                                        
                                        <ng-container *ngIf="section.SectionId == 1">
                                            <div class="level{{answer.Level}}">
                                                <div class="col-md-12">
                                                    <div class="container-fluid">
                                                        <h4>Level {{answer.Level}}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="col-md-12" style="margin-bottom: 3px;">
                                            <div class="col-md-6" [ngClass]="{'negativelyKeyed': answer.NegativelyKeyed}">
                                                <p *ngIf="section.SectionId == 1"><b>{{answer.QuestionNumber}}</b>. {{answer.QuestionText}}</p>
                                                <p *ngIf="section.SectionId == 2"><b>{{answer.QuestionNumber}}</b>. {{answer.QuestionText}}</p>
                                            </div>
                                            <div class="col-md-6">
                                                <!--[style.width.%]="value"-->
                                                <div class="bar" style="min-width:20%;" [ngStyle]="{'width.%': answer.AnswerValue}">
                                                    <span> {{answer.AnswerText}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="show360Section" id="360Tab" class="tab-pane fade graphics360">
                            <div class="container-fluid">
                                <!--section1 360-->
                                <div>
                                    <p><b>Your Ability to:</b></p>
                                    <p><b>(1=very poor;2=below to average;3=average;4=adobe average;5=excellent)</b></p>
                                    <ng-container *ngFor="let question of questions360_1; let i = index;">
                                        <div class="row">
                                            <div class="flexbox-container">
                                                <div class="col-xs-12 col-md-3 align">
                                                    <p class="graphicTitle">{{question[0]}}</p>
                                                </div>


                                                <div class="col-xs-12 col-md-4 images">
                                                    <canvas baseChart
                                                            [datasets]="question[1]"
                                                            [labels]="question[2]"
                                                            [options]="graphic360_1_1_Options"
                                                            [legend]="false"
                                                            chartType="horizontalBar"
                                                            [colors]="colors360"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                </div>

                                <!--section2 360-->
                                <div>
                                    <p><b>Your Ability to:</b></p>
                                    <p><b>(1=very poor;2=below to average;3=average;4=adobe average;5=excellent)</b></p>
                                    <ng-container *ngFor="let question of questions360_2; let i = index;">
                                        <div class="row">
                                            <div class="flexbox-container">
                                                <div class="col-md-3 text-right">
                                                    <p class="graphicTitle">{{question[0]}}</p>
                                                </div>


                                                <div class="col-md-4 images">
                                                    <canvas baseChart
                                                            [datasets]="question[1]"
                                                            [labels]="question[2]"
                                                            [options]="graphic360_1_1_Options"
                                                            [legend]="false"
                                                            chartType="horizontalBar"
                                                            [colors]="colors360"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
